// src/components/Footer.js
import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      style={styles.footer}
    >
      <div style={styles.container}>
        <p>© {new Date().getFullYear()} Quadramelo. Todos los derechos reservados.</p>
        <p>Contacto: quadramelo.ve@gmail.com</p>
      </div>
    </motion.footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#212529',
    color: '#f8f9fa',
    padding: '2rem 1rem',
    textAlign: 'center',
  },
  container: {
    maxWidth: '800px',
    margin: '0 auto',
  }
};

export default Footer;